import { API_URL } from '../../components/common/Constants';
import {
  IStandardAPIResponse,
  ICustomerReportStatusCount,
  IMomStatusCount,
  IMomStatusDetails,
  IManualReadingStatusCount,
  ISlaMatrixAlert,
  ISensorReadingCount,
  IMomStatusGraphCount
} from '../../vm';
import {
  httpClient,
  handleErrorResp,
  getToken,
} from '../UtilService';

export async function getCustomerReportStatusCount(searchObj: {
  date: Date | string,
  datacenterIds: string[],
  cemIds: string[]
}): Promise<IStandardAPIResponse<ICustomerReportStatusCount>> {
  try {
    let res = await httpClient<ICustomerReportStatusCount>(`customer-report-status-count`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMomStatusCount(searchObj: {
  startDate: Date | string,
  endDate: Date | string,
  cemIds: string[]
}): Promise<IStandardAPIResponse<Array<IMomStatusCount>>> {
  try {
    let res = await httpClient<Array<IMomStatusCount>>(`mom-status-count`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMomStatusDetails(searchObj: {
  startDate: Date | string,
  endDate: Date | string,
  status: string[],
  cemIds: string[],
  // customerIds: string[],
  sendCustomerDetails: boolean
}): Promise<IStandardAPIResponse<IMomStatusDetails>> {
  try {
    let res = await httpClient<IMomStatusDetails>(`mom-status-details`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMomStatusCountByCEM(searchObj: {
  startDate: Date | string,
  endDate: Date | string,
}): Promise<IStandardAPIResponse<Array<IMomStatusGraphCount>>> {
  try {
    let res = await httpClient<Array<IMomStatusGraphCount>>(`mom-status-count/cem`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMomStatusDetailsExcel(search: any): Promise<Response> {
  try {
    let res = await fetch(`${API_URL}mom-status-details`, {
      method: "POST",
      credentials: 'include', // Enable credentials for CORS
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        at: getToken()
      },
      body: JSON.stringify({ ...search, isExport: true })
    });
    return res;
  } catch (err: any) {
    return err;
  }
}
export async function getManualReadingStatusCount(searchObj: {
  startDate: Date | string,
  endDate: Date | string,
  datacenterId: string
}): Promise<IStandardAPIResponse<Array<IManualReadingStatusCount>>> {
  try {
    let res = await httpClient<Array<IManualReadingStatusCount>>(`manual-reading-status-count`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getManualReadingStatusDetails(searchObj: {
  startDate: Date | string,
  endDate: Date | string,
  datacenterId: string,
  unit: string
}): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`manual-reading-status-details`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getSlaMatrixAlert(searchObj: {
  date: Date | string,
  datacenterIds: string[]
}): Promise<IStandardAPIResponse<ISlaMatrixAlert>> {
  try {
    let res = await httpClient<ISlaMatrixAlert>(`sla-matrix-alert-count`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getSlaMatrixAlertDetails(searchObj: {
  date: Date | string,
  datacenterIds: string[],
  type: string
}): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`sla-matrix-alert-details`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getSensorReadingsCount(searchObj: {
  date: Date | string,
  datacenterId: string
}): Promise<IStandardAPIResponse<ISensorReadingCount>> {
  try {
    let res = await httpClient<ISensorReadingCount>(`sensor-reading-count`, 'POST', searchObj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}